import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import useMediaQuery from '@mui/material/useMediaQuery';


// Components 

import NavigationBar from './navigation/NavigationBar';
import CategoryTitle from './categories/items/CategoryTitle';
import ProgressColumn from './navigation/ProgressColumn';
import EditUpdater from './actions/EditUpdater';

import PatientInfo from './categories/PatientInfo';
import ContactInfo from './categories/ContactInfo';
import EmergencyContact from './categories/EmergencyContact';
import InsuranceDetails from './categories/InsuranceDetails';
import ExtraInformation from './categories/ExtraInformation';
import Confirmation from './categories/Confirmation';

import ExitProcess from './actions/ExitProcess';
import { setErroredCategories, setSection } from '../../../../../redux/features/doctor/Dashboard/patients/createPatient';
import DateSelector from './categories/options/DateSelector';

const CreatePatient: React.FC = () => {

  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  // -- 

  const scrollListRef = useRef() as any; 

  const isPortraitMode = useMediaQuery('(orientation: portrait)');

  const colors = useAppSelector(state => state.theme.colors);

  const section = useAppSelector((state) => state.createPatient.section); 
  const interfaceSection = useAppSelector((state) => state.patient.section); 
  const completedFields = useAppSelector((state) => state.createPatient.completedFields); 
  const editedPatient = useAppSelector(state => state.createPatient.editedPatient); 
  const editedPatientChange = useAppSelector(state => state.createPatient.editedPatientChange);  
  const erroredFields = useAppSelector(state => state.createPatient.erroredFields);  
  const isDateOfBirthSelectorOpened = useAppSelector((state) => state.createPatient.isDateOfBirthSelectorOpened); 
  const isPopupOpened = useAppSelector((state) => state.popup.isPopupOpened);
  const action = useAppSelector(state => state.popup.action); 

  // -- 

  window.onbeforeunload = function (e: any) {

    if ((completedFields?.length > 0) && (editedPatientChange)) { 

      // For IE and Firefox

      if (e) {
        e.returnValue;
      }; 
    
      // For Safari
      return e.returnValue;

    };

  };  
  
  // -- 

  useEffect(() => { 

    if (section) { 

      scrollListRef.current.scrollTo(0, 0);

    }; 

  },[section]); 

  // -- 

  useEffect(() => { 

    if (erroredFields?.length === 0) { 

      dispatch(setErroredCategories([])); 

    }; 

  },[erroredFields]); 

  // -- 

  return (

    <Box
      sx={{ 
        display: 'flex', 
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        width: '100%',
        height: '100%', 
        bottom: 0,
        position: 'absolute',
        backgroundColor: colors?.interface,
        transition: 'left 0.3s',
    }}>

      <ProgressColumn isPortraitMode={isPortraitMode} />

      <Box
        sx={{
          display: 'flex', 
          flexDirection: 'column',
          alignItems: 'center',
          width: '70%',
          height: '95%', 
          bottom: 0,
          borderRadius: 5,
          backgroundColor: colors?.container,
          paddingTop: 1, 
          transition: 'left 0.3s',    
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
        }}
      >

          <Box
            ref={scrollListRef}
            sx={{
              width: '100%',
              padding: '2rem',
              "& .MuiTextField-root": { marginBottom: '1rem' },
              "& .MuiFormControl-root": { marginBottom: '1rem' },
              maxHeight: '80vh',
              overflow: 'auto',
              scrollbarWidth: 'none',
            }}
          >

            <CategoryTitle /> 

            { section === 'patientInfo' && <PatientInfo />}

            { section === 'contactInfo' && <ContactInfo />}

            { section === 'emergencyContact' && <EmergencyContact />}

            { section === 'insuranceDetails' && <InsuranceDetails />}

            { section === 'extraInformation' && <ExtraInformation />}

            { section === 'confirmation' && <Confirmation />}

            <NavigationBar />

          </Box>

      </Box>

      <EditUpdater />

      {isDateOfBirthSelectorOpened && <DateSelector />} 

    </Box>
  );
};

export default CreatePatient;